import BaseService from '../BaseService';

class MarketingService extends BaseService {
    getAll = (filters) => this.post('/warehouse/marketing/marketingList', filters || { });
    sendMarketing = (data) => this.post('/warehouse/marketing/marketingSend', data);
}

export default new MarketingService();